import React, { useState } from 'react';
import { callApiPost } from '../Helper/Network';

import hyappLogo from '../resource/hyapp/logo.png';
import haccproLogo from '../resource/haccpro/logo.png'
import { Form, Icon, Button } from 'react-bulma-components';

import { toast } from 'react-toastify';

import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../locale/useTranslation';
function PasswordReset(props) {
  const { t, language, setLanguage } = useTranslation();
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const tokenParam = queryParameters.get("token");
  const emailParam = queryParameters.get("email");
  const modeParam = queryParameters.get("mode");

  const [token, setToken] = useState(tokenParam);
  const [email, setEmail] = useState(emailParam);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [consent, setConsent] = useState(false);


  const navigate = useNavigate();

  const save = async () => {
    if (password !== confirmPassword) {
      toast.error(t("Les mots de passes saisis ne correspondent pas"));
      return;
    }
    if (!consent) {
      toast.error(t("Vous devez donner votre consentement"));
      return;
    }
    var passwordReset = {
      token: token,
      email: email,
      password: password,
      confirmPassword: confirmPassword
    }

    try {
      await callApiPost("/reset", passwordReset);
      navigate("/login?mode=" + modeParam);
    }
    catch (error) {
    }
  }

  const handleValidate = (event) => {
    if (event.key === 'Enter') {
      // 👇 Get input value
      save();
    }
  };

  return (
    <>
      <div className="container is-centered">
        <div className="columns is-centered">
          <div className="column is-12-mobile is-6-tablet is-6-desktop">

                        <div style={{textAlign: 'center', marginTop: '20px'}}>
                            {
                            process.env.REACT_APP_APP_VARIANT === "hyapp" ? <img src={hyappLogo} width="200px" alt="Logo HyAPP" /> : null
                            } 
                            {
                            process.env.REACT_APP_APP_VARIANT === "haccpro" ? <img src={haccproLogo} width="300px" alt="Logo HACCPro" /> : null
                            }             
                        </div>
                        <div className="box" style={{ maxWidth: "400px", margin: "0 auto" }}>
                            <h3 className="title is-5">{t("Réinitialisation de mot de passe")}</h3>

                            <div className="field">
                                <label className="label required">{t("E-mail")}</label>
                                <div className="control">
                                    <input
                                    className="input"
                                    type="text"
                                    name="email"
                                    placeholder={t("E-mail")}
                                    value={email}
                                    readOnly={true}
                                    onChange={e => setEmail(e.target.value)}
                                    onKeyDown={handleValidate}
                                    />
                                </div>
                            </div>

                            <div className="field">
                              <div className="is-flex is-justify-content-space-between">
                                <label className="label required">{t("Mot de passe")}</label>
                              </div>
                              <div className="control">
                                <input
                                  className="input"
                                  type="password"
                                  name="password"
                                  placeholder={t("Mot de passe")}
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                />
                              </div>
                            </div>

                            <div className="field">
                              <div className="is-flex is-justify-content-space-between">
                                <label className="label required">{t("Confirmez votre mot de passe")}</label>
                              </div>
                              <div className="control">
                                <input
                                  className="input"
                                  type="password"
                                  name="password"
                                  placeholder={t("Mot de passe")}
                                  value={confirmPassword}
                                  onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                              </div>
                            </div>


                            <div className="field">
                              <div className="control">
                                <label className="checkbox">
                                <input
                                  type="checkbox"
                                  checked={consent}
                                  onChange={e => setConsent(e.target.checked)}
                                />
                                {t("En cochant cette case, vous autorisez " + process.env.REACT_APP_TITLE + " à enregistrer vos données utilisateurs")}
                                </label>
                              </div>
                            </div>


                            <Button.Group style={{justifyContent: 'center'}}>
                                <Button color="black" onClick={save}>
                                <Icon align="left"  style={{marginRight: "0px", marginLeft: "0px"}}>
                                    <i className="fa fa-envelope"/>
                                </Icon>
                                {t("Sauvegarder les modifications")}</Button>
                            </Button.Group>  
                        </div>             
          </div>
        </div>
      </div>
    </>
  );
}

export default PasswordReset;
